import {
  makeAuthorizedGetRequestToBackend,
  makeUrl,
} from "./helpers/backendApi";
import { useAsync } from "react-use";
import { useMe } from "./hooks/useMe";

export function useAppModeEndpoint(endpoint, appMode) {
  const me = useMe();
  const fn = async () => {
    if (me.loading || !appMode) return {};
    const { data } = await makeAuthorizedGetRequestToBackend({
      url: makeUrl({ endpoint, appMode }),
    });
    return data;
  };
  const { loading, value: data } = useAsync(fn, [
    endpoint,
    appMode,
    me.loading,
  ]);
  if (me.loading || !appMode) return { loading: true, value: undefined };
  return { loading, data };
}

export function useModedEndpoint(endpoint, appMode, itinMode) {
  const me = useMe();
  const notReady = me.loading || !appMode || !itinMode;
  const fn = async () => {
    if (notReady) return {};
    const { data } = await makeAuthorizedGetRequestToBackend({
      url: makeUrl({ endpoint, appMode, itinMode }),
    });
    return data;
  };
  const { loading, value: data } = useAsync(fn, [
    endpoint,
    appMode,
    itinMode,
    me.loading,
  ]);
  if (notReady) return { loading: true, value: undefined };
  return { loading, data };
}
